export enum HomematchThumbDirection {
    Down = "down",
    Up = "up"
}

export type IHomematchThumbCallbacks = {
    [HomematchThumbDirection.Down]: (preleadId: number) => void;
    [HomematchThumbDirection.Up]: (preleadId: number) => void;
};

export interface IHomematchThumbsProps {
    disabled: boolean;
    handleThumbClick: (direction: HomematchThumbDirection) => void;
}
export enum HomematchThumbDirection {
    Down = "down",
    Up = "up"
}

export type IHomematchThumbCallbacks = {
    [HomematchThumbDirection.Down]: (preleadId: number) => void;
    [HomematchThumbDirection.Up]: (preleadId: number) => void;
};

export interface IHomematchThumbsProps {
    disabled: boolean;
    handleThumbClick: (direction: HomematchThumbDirection) => void;
}
